import React from 'react'
interface Props {
  color: string
  styleCssImage:string
}

const Gift: React.FC<Props> = ({ styleCssImage, color }) => {
  return (

<svg width="31" height="31" viewBox="0 0 31 31"
className={styleCssImage}
  fill="none"
 xmlns="http://www.w3.org/2000/svg">
<path d="M27.1817 28.3042V14.1543H3.81763V28.3042C3.81763 28.8565 4.26534 29.3042 4.81763 29.3042H26.1817C26.734 29.3042 27.1817 28.8565 27.1817 28.3042Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M15.5 29.3044V14.1504" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M29.0912 9.39537V13.1543C29.0912 13.7066 28.6435 14.1543 28.0912 14.1543H2.90894C2.35665 14.1543 1.90894 13.7066 1.90894 13.1543V9.39537C1.90894 8.84308 2.35665 8.39537 2.90894 8.39537H28.0912C28.6435 8.39537 29.0912 8.84308 29.0912 9.39537Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M15.5001 8.39583C15.5001 6.45833 13.2397 1.9375 9.84908 1.9375C4.33305 1.9375 6.34241 8.39583 8.98253 8.39583" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M15.5 8.39583C15.5 6.45833 17.7604 1.9375 21.151 1.9375C26.6671 1.9375 24.6577 8.39583 22.0176 8.39583" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )}
export default Gift

